import { Fragment, useRef, useCallback, ReactNode, MutableRefObject } from 'react';

export type FileInputChildrenType = {
  handleInputChange: (e: any) => void;
  handleClick?: () => void;
  inputRef: MutableRefObject<HTMLInputElement>;
  accept: string;
};

export type FileInputProps = {
  accept?: string;
  onChange: (files: File[]) => void;
  children: ({ handleInputChange }: FileInputChildrenType) => ReactNode;
};

export const FileInput = ({ accept = '*/*', onChange, children }: FileInputProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const ref = useRef(false);

  const handleInputChange = useCallback(e => {
    if (!ref.current && e.target.files.length !== 0) {
      onChange(Object.values(e.target.files));
    }
  }, []);

  const handleClick = useCallback(() => {
    // Unless you won't be allowed to select the same file twice
    inputRef.current.value = null;
  }, [inputRef]);

  return (
    <Fragment>
      {children && children({ handleInputChange, handleClick, inputRef, accept })}
    </Fragment>
  );
};
